// TODO (Justas - NX migration): Make `window.d.ts` available across libs
const _env = typeof window !== 'undefined' ? (window as any).env || {} : {};

export type AppName = 'console' | 'console-oneclick';

export const isOneClick = (): boolean => {
  const env = typeof window !== 'undefined' ? (window as any).env || {} : {};
  return env.APP_NAME === 'console-oneclick';
};

export const IS_DEV = _env.VITE_ENV === 'dev-master';
export const IS_PROD_US = _env.VITE_ENV === 'prod-master';
export const IS_PROD_EU = _env.VITE_ENV === 'prod-eu';
export const IS_PROD_INDIA = _env.VITE_ENV === 'prod-india';
export const IS_PROD = IS_PROD_US || IS_PROD_EU || IS_PROD_INDIA;
export const IS_LOCALHOST =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';

const ONE_CLICK_ORIGIN_BY_ENV: Record<string, string> = {
  'prod-master': 'https://app.console.cast.ai',
  'prod-eu': 'https://app.console.eu.cast.ai',
  'prod-india': 'https://app.console.india.cast.ai',
  'dev-master': 'https://app.console.dev-master.cast.ai',
};

export const getOneClickConsoleOrigin = (): string => {
  if (
    typeof window === 'undefined' ||
    window.location.hostname === 'localhost'
  ) {
    return ONE_CLICK_ORIGIN_BY_ENV['dev-master'];
  }

  const viteEnv = (window as any).env?.VITE_ENV as string | undefined;
  return (
    (viteEnv && ONE_CLICK_ORIGIN_BY_ENV[viteEnv]) ||
    ONE_CLICK_ORIGIN_BY_ENV['dev-master']
  );
};

/** @alias */
export const ANALYTICS_ENABLED = IS_PROD;

export const HUBSPOT_COOKIE_KEY = 'hubspotutk';
export const AUTH_PROVIDER_QUERY_KEY = 'auth-provider';
export const REBALANCE_NODES_KEY = 'rebalance-nodes';

export const MOST_EXPENSIVE_ITEM_COLOR_MAP = {
  insignificant: 'grey.200',
  colorByUsageRank: [
    'blue.700',
    'aqua.600',
    'indigo.100',
    'yellow.200',
    'green.300',
  ],
};
